import { FC, memo } from 'react';
import { Image } from 'shared/ui/image/image';
import { ICONS } from 'shared/constants/images';

interface IconProps {
  pathToIcon: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  filter?: string; // Optional CSS filter for color manipulation
  fallbackIcon?: string; // Optional fallback icon path
}

export const Icon: FC<IconProps> = memo((props: IconProps) => {
  const {
    pathToIcon,
    className,
    onClick,
    filter,
    fallbackIcon,
    size = 18,
  } = props;

  // Default fallback icon - use cube-outline from your existing icons or a generic placeholder
  const defaultFallback = fallbackIcon || ICONS.missingIcon;

  return (
    <Image
      src={pathToIcon}
      style={{
        width: size,
        height: size,
        minHeight: size,
        minWidth: size,
        filter: filter,
      }}
      className={className}
      onClick={onClick}
      error={defaultFallback}
    />
  );
});
